/**
 * Orion Analytics
 * Financial Intelligence Platform
 *
 * Copyright (c) 2026 Santosh Bag / Orion Analytics Ltd.
 * All rights reserved.
 *
 * Software Development by Cosmo Codeworks Ltd
 *
 * Unauthorized copying, modification, distribution,
 * or commercial use is prohibited.
 */

// src/components/software/SoftwareCTA.jsx

import React from "react";

import {
  Smartphone,
  ArrowRight,
} from "lucide-react";

const SoftwareCTA = () => {

  return (

    <section
      className="
        py-24
        px-6
        lg:px-10
      "
    >

      <div
        className="
          max-w-7xl
          mx-auto

          rounded-[42px]

          bg-gradient-to-r
          from-slate-900
          via-blue-900
          to-blue-600

          p-14

          text-white

          shadow-[0_20px_60px_rgba(37,99,235,0.20)]
        "
      >

        <div
          className="
            grid
            lg:grid-cols-2
            gap-10
            items-center
          "
        >

          {/* =====================================
              LEFT
          ===================================== */}

          <div>

            <div
              className="
                inline-flex
                items-center
                gap-2

                px-4
                py-2

                rounded-full

                bg-white/10
                backdrop-blur-md

                border
                border-white/20

                text-sm
                font-semibold

                mb-6
              "
            >
              <Smartphone size={16} />

              Orion Software Ecosystem
            </div>

            <h2
              className="
                text-5xl
                lg:text-6xl

                font-black

                leading-tight

                mb-6
              "
            >
              Ready To Experience
              <span
                className="
                  block
                  text-blue-300
                "
              >
                Orion Software?
              </span>
            </h2>

            <p
              className="
                text-xl
                text-white/85

                leading-relaxed

                max-w-2xl
              "
            >
              Explore the growing Orion
              ecosystem of web platforms,
              mobile applications and future
              financial intelligence tools
              built for investors and traders.
            </p>

          </div>

          {/* =====================================
              RIGHT
          ===================================== */}

          <div
            className="
              flex
              flex-col
              lg:items-end
              gap-5
            "
          >

            <a href="/software/#products">

              <button
                className="
                  bg-white

                  text-blue-800

                  px-8
                  py-4

                  rounded-2xl

                  font-bold
                  text-lg

                  shadow-lg

                  hover:scale-105

                  transition-all

                  flex
                  items-center
                  gap-3
                "
              >
                Download Orion Edge

                <ArrowRight size={20} />
              </button>

            </a>


            <a href="/software/#roadmap">

              <button
                className="
                  border
                  border-white/30

                  bg-white/10

                  backdrop-blur-md

                  text-white

                  px-8
                  py-4

                  rounded-2xl

                  font-bold
                  text-lg

                  hover:bg-white/20

                  transition-all
                "
              >
                View Product Roadmap
              </button>

            </a>

          </div>

        </div>

      </div>

    </section>

  );

};

export default SoftwareCTA;